/**
 * `UserCommunication.authorUserId` and `Recipient.userId` hold one of three things, and a
 * reader that treats the last two as interchangeable gets the wrong answer:
 *
 * - a resolved platform id (a Clerk id, an igsid, a Teams objectId…);
 * - the sender's own address, when every identity lookup COMPLETED and matched nobody —
 *   ~98% of the column by construction;
 * - `UNRESOLVED_USER_ID`, when a lookup did not complete at all.
 *
 * The third exists because the second cannot carry that meaning: an address is the normal,
 * successful answer, so writing one after a failed lookup makes the failure invisible and
 * unfindable. Anything asking "is this from someone other than the account owner?" must
 * treat the marker as "cannot say", never as "yes".
 *
 * It lives here rather than in `apps/api` because the web app's unread check needs it too,
 * and a duplicated literal is exactly how the two would drift apart.
 */
export const UNRESOLVED_USER_ID = 'unresolved';
